import { __assign, __extends, __spreadArrays } from "tslib";
import { CoherenceTheme } from '@cseo/styles';
import { CommandBarButton, css, FontSizes, initializeIcons, Link, memoizeFunction, mergeStyleSets, OverflowSet, ResizeGroup } from '@fluentui/react';
import React from 'react';
import { HeaderActionsStyles, onRenderCommandBarButton } from '../Common/CoherenceHeaderHelpers';
import { GlobalSearch } from './GlobalSearch/GlobalSearch';
import { SearchBoxOverlay } from './SearchBoxOverlay';
var buttonWidth = 48;
var getStylesInternal = memoizeFunction(function (numRightItems, theme) {
    return mergeStyleSets({
        root: {
            backgroundColor: theme ? theme.palette.themePrimary : CoherenceTheme.palette.themePrimary,
            fontFamily: "'Segoe UI', 'Segoe UI Web(West European)', 'Segoe UI', -apple-system, BlinkMacSystemFont, 'Roboto', 'Helvetica Neue', 'sans-serif'",
            alignItems: 'center',
            height: '48px',
            overflow: 'hidden',
            display: 'grid',
            gridTemplateColumns: '1fr 468px 1fr',
            selectors: {
                '@media (min-width:1366px) and (max-width: 1920px)': {
                    gridTemplateColumns: '1fr 468px 1fr'
                },
                '@media (min-width:1024px) and (max-width: 1365px)': {
                    gridTemplateColumns: '1fr 468px 1fr'
                },
                '@media (min-width:640px) and (max-width: 1023px)': {
                    gridTemplateColumns: '1fr 274px 1fr'
                },
                '@media (min-width: 320px) and (max-width: 639px)': {
                    gridTemplateColumns: '1fr ' + buttonWidth + 'px ' + (numRightItems * buttonWidth) + 'px'
                },
                '@media (max-width: 320px)': {
                    gridTemplateColumns: '1fr ' + buttonWidth + 'px ' + (numRightItems * buttonWidth) + 'px'
                }
            }
        },
        titleContainer: {
            height: '100%',
            paddingLeft: '16px',
            paddingRight: '12px',
            alignSelf: 'center',
            fontSize: '16px',
            overflow: 'hidden',
            minWidth: '160px',
            display: 'flex',
            alignItems: 'center'
        },
        searchBoxContainer: {
            alignSelf: 'center'
        },
        floatingSearchRoot: {
            width: '100%',
            backgroundColor: theme ? theme.palette.themePrimary : CoherenceTheme.palette.themePrimary
        },
        rightItemsContainer: {
            height: '48px',
            overflow: 'hidden'
        },
        overflowSet: {}
    });
});
var resizeGroupStyles = {
    flex: 1,
    overflow: 'hidden'
};
var actionsGroupResizeGroupContainer = {
    display: 'flex',
    justifyContent: 'flex-end'
};
var actionsGroupOverflowSetStyles = {
    root: {
        justifyContent: 'flex-end'
    }
};
initializeIcons();
var HeaderBanner = (function (_super) {
    __extends(HeaderBanner, _super);
    function HeaderBanner(props) {
        var _this = _super.call(this, props) || this;
        _this._actionsResizeGroup = React.createRef();
        _this._onRenderSearchBoxData = function (data) {
            var _a = _this.props, searchBoxProps = _a.searchBoxProps, headerLabel = _a.headerLabel;
            if (data.renderState === 'ButtonOnly') {
                return (onRenderCommandBarButton({
                    key: 'Search button',
                    name: 'Search',
                    ariaLabel: 'Search button. Select to activate search box.',
                    iconProps: {
                        iconName: 'Search'
                    },
                    onClick: _this._onSearchOverlayOpen
                }));
            }
            else {
                return (React.createElement(GlobalSearch, __assign({ role: "search" }, searchBoxProps, { headerLabel: headerLabel, suggestions: ((searchBoxProps === null || searchBoxProps === void 0 ? void 0 : searchBoxProps.suggestions) !== null && (searchBoxProps === null || searchBoxProps === void 0 ? void 0 : searchBoxProps.suggestions) !== undefined) ? searchBoxProps === null || searchBoxProps === void 0 ? void 0 : searchBoxProps.suggestions : [], onSearch: _this._onSearch, onChange: _this._onChange })));
            }
        };
        _this._onSearch = function (newValue) {
            var searchBoxProps = _this.props.searchBoxProps;
            _this.setState({
                searchText: newValue
            });
            if (searchBoxProps && searchBoxProps.onSearch) {
                searchBoxProps.onSearch(newValue);
            }
        };
        _this._onChange = function (event, newValue) {
            var searchBoxProps = _this.props.searchBoxProps;
            _this.setState({
                searchText: newValue
            });
            if (searchBoxProps && searchBoxProps.onChange) {
                searchBoxProps.onChange(event, newValue);
            }
        };
        _this._onRenderActionsGroup = function (data) {
            var overflowSetProps = _this.props.overflowSetProps;
            var Styles = _this._getStyles();
            return (React.createElement(OverflowSet, __assign({}, overflowSetProps, { role: undefined, className: Styles.overflowSet, items: data.primaryItems, overflowItems: data.overflowItems, onRenderItem: onRenderCommandBarButton, onRenderOverflowButton: _this._onRenderActionsOverflowButton, styles: actionsGroupOverflowSetStyles })));
        };
        _this._onSearchBoxReduceData = function (data) {
            var renderState = data.renderState;
            if (renderState !== 'ButtonOnly') {
                var newData = __assign(__assign({}, data), { renderState: 'ButtonOnly' });
                newData.cacheKey = _this._computeSearchBoxCacheKey(newData);
                return newData;
            }
            return undefined;
        };
        _this._onSearchBoxGrowData = function (data) {
            var renderState = data.renderState;
            if (renderState !== 'SearchBox') {
                var newData = __assign(__assign({}, data), { renderState: 'SearchBox' });
                newData.cacheKey = _this._computeSearchBoxCacheKey(newData);
                return newData;
            }
            return undefined;
        };
        _this._onSearchOverlayOpen = function () {
            _this.setState({ isFloatingSearchVisible: true });
        };
        _this._onSearchOverlayClose = function () {
            _this.setState({ isFloatingSearchVisible: false });
        };
        _this._onSearchChange = function (event, value) {
            var searchBoxProps = _this.props.searchBoxProps;
            _this.setState({ searchText: value });
            if (searchBoxProps && searchBoxProps.onChange) {
                searchBoxProps.onChange(event, value);
            }
        };
        _this._onSearchClear = function () {
            var searchBoxProps = _this.props.searchBoxProps;
            _this.setState({ searchText: undefined });
            if (searchBoxProps && searchBoxProps.onClear) {
                searchBoxProps.onClear();
            }
        };
        _this._onRenderActionsOverflowButton = function (overflowItems) {
            var combinedOverflowItems = overflowItems.map(function (x) { return (__assign(__assign({}, x), { renderedInOverflow: true, onRender: onRenderCommandBarButton })); });
            var overflowProps = {
                id: 'coher-header-overflow-button-id',
                checked: overflowItems.some(function (i) { return i.checked === true; }),
                ariaLabel: 'Access additional app options. Select to open menu',
                className: css('ms-CommandBar-overflowButton', HeaderActionsStyles.rightItemButton),
                menuProps: { items: combinedOverflowItems, isBeakVisible: false },
                menuIconProps: {
                    iconName: 'More',
                    className: HeaderActionsStyles.rightItemButtonIcon
                },
                styles: {
                    menuIcon: {
                        color: (_this.props.theme ? _this.props.theme.palette.white : CoherenceTheme.palette.white) + ' !important',
                        backgroundColor: 'transparent !important',
                        fontSize: FontSizes.size16
                    }
                }
            };
            return React.createElement(CommandBarButton, __assign({}, overflowProps));
        };
        _this._onActionsReduceData = function (data) {
            var primaryItems = data.primaryItems, overflowItems = data.overflowItems;
            if (primaryItems && primaryItems.length) {
                var movedItems = primaryItems.map(function (x) { return (__assign(__assign({}, x), { renderedInOverflow: true })); });
                var newData = __assign(__assign({}, data), { primaryItems: [], overflowItems: __spreadArrays(overflowItems, movedItems) });
                newData.cacheKey = _this._computeActionsCacheKey(newData);
                return newData;
            }
            return undefined;
        };
        _this._onActionsGrowData = function (data) {
            var primaryItems = data.primaryItems, overflowItems = data.overflowItems;
            if (overflowItems && overflowItems.length) {
                var movedItems = overflowItems.map(function (x) { return (__assign(__assign({}, x), { renderedInOverflow: false })); });
                var newData = __assign(__assign({}, data), { primaryItems: __spreadArrays(primaryItems, movedItems), overflowItems: [] });
                newData.cacheKey = _this._computeActionsCacheKey(newData);
                return newData;
            }
            return undefined;
        };
        _this._getActionsCount = function () {
            var actions = _this.props.actions;
            var count = 0;
            if (actions && actions.flexItems && actions.flexItems.length) {
                count++;
            }
            if (actions && actions.staticItems && actions.staticItems.length) {
                count++;
            }
            return count;
        };
        _this._getStyles = function () {
            return getStylesInternal(_this._getActionsCount(), _this.props.theme);
        };
        _this.state = {
            isFloatingSearchVisible: false,
            searchText: undefined
        };
        return _this;
    }
    HeaderBanner.prototype.render = function () {
        if (this.state.isFloatingSearchVisible) {
            return this._renderFloatingSearchBox();
        }
        else {
            var Styles = this._getStyles();
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: Styles.root, role: 'banner', "aria-label": this.props.headerLabel },
                    React.createElement("div", { className: Styles.titleContainer }, this._renderAppName()),
                    React.createElement("div", { className: Styles.searchBoxContainer }, this._renderSearchBox()),
                    React.createElement("div", { className: Styles.rightItemsContainer, role: 'menubar' }, this._renderActionsGroup()))));
        }
    };
    HeaderBanner.prototype.remeasure = function () {
        if (this._actionsResizeGroup.current) {
            this._actionsResizeGroup.current.remeasure();
        }
    };
    HeaderBanner.prototype._renderAppName = function () {
        var appNameSettings = this.props.appNameSettings;
        if (!appNameSettings || !appNameSettings.label) {
            return null;
        }
        return (React.createElement(Link, __assign({ href: appNameSettings.linkUrl || '/', "aria-label": appNameSettings.ariaLabel }, appNameSettings.linkProps), appNameSettings.label));
    };
    HeaderBanner.prototype._renderSearchBox = function () {
        var searchBoxProps = this.props.searchBoxProps;
        if (!searchBoxProps || !searchBoxProps.enabled) {
            return null;
        }
        else if (searchBoxProps.onRender) {
            return searchBoxProps.onRender();
        }
        var searchBoxData = {
            renderState: 'SearchBox',
            cacheKey: ''
        };
        return (React.createElement(ResizeGroup, { data: searchBoxData, onReduceData: this._onSearchBoxReduceData, onGrowData: this._onSearchBoxGrowData, onRenderData: this._onRenderSearchBoxData, style: resizeGroupStyles }));
    };
    HeaderBanner.prototype._renderFloatingSearchBox = function () {
        var _a = this.props, searchBoxProps = _a.searchBoxProps, headerLabel = _a.headerLabel;
        var searchText = this.state.searchText;
        var Styles = this._getStyles();
        return (React.createElement("div", { className: Styles.floatingSearchRoot },
            React.createElement(SearchBoxOverlay, { searchBoxProps: __assign(__assign({}, searchBoxProps), { onChange: this._onSearchChange, onClear: this._onSearchClear, value: searchText, headerLabel: headerLabel, suggestions: ((searchBoxProps === null || searchBoxProps === void 0 ? void 0 : searchBoxProps.suggestions) !== null && (searchBoxProps === null || searchBoxProps === void 0 ? void 0 : searchBoxProps.suggestions) !== undefined) ? searchBoxProps === null || searchBoxProps === void 0 ? void 0 : searchBoxProps.suggestions : [] }), onClose: this._onSearchOverlayClose, dismissOnClear: false, dismissOnSearch: false })));
    };
    HeaderBanner.prototype._renderActionsGroup = function () {
        var actions = this.props.actions;
        var hasActions = actions && ((actions.flexItems && actions.flexItems.length) || (actions.staticItems && actions.staticItems.length));
        if (!hasActions) {
            return null;
        }
        var actionsData = {
            primaryItems: actions && actions.flexItems ? __spreadArrays(actions.flexItems) : [],
            overflowItems: [],
            cacheKey: ''
        };
        var staticActions = undefined;
        if (actions && actions.staticItems && actions.staticItems.length) {
            staticActions = actions.staticItems.map(function (x) { return onRenderCommandBarButton(x); });
        }
        return (React.createElement("div", { style: actionsGroupResizeGroupContainer },
            React.createElement(ResizeGroup, { componentRef: this._actionsResizeGroup, data: actionsData, onReduceData: this._onActionsReduceData, onGrowData: this._onActionsGrowData, onRenderData: this._onRenderActionsGroup, style: resizeGroupStyles }),
            React.createElement("div", null, staticActions)));
    };
    HeaderBanner.prototype._computeSearchBoxCacheKey = function (data) {
        var renderState = data.renderState;
        return renderState + '';
    };
    HeaderBanner.prototype._computeActionsCacheKey = function (data) {
        var primaryItems = data.primaryItems, overflowItems = data.overflowItems;
        var returnKey = function (acc, current) {
            var cacheKey = current.cacheKey || current.key;
            return acc + cacheKey;
        };
        var primaryKey = primaryItems.reduce(returnKey, '');
        var overflowKey = overflowItems.length ? 'overflow' : '';
        return [primaryKey, overflowKey].join(' ');
    };
    return HeaderBanner;
}(React.Component));
export { HeaderBanner };
//# sourceMappingURL=HeaderBanner.js.map